<button mat-icon-button (click)="filter.resetColumns()">
  <mat-icon>close</mat-icon>
</button>
